import { render, staticRenderFns } from "./IndividualProjectTable.vue?vue&type=template&id=4bb22d9a"
import script from "./IndividualProjectTable.vue?vue&type=script&lang=js"
export * from "./IndividualProjectTable.vue?vue&type=script&lang=js"
import style0 from "./IndividualProjectTable.vue?vue&type=style&index=0&id=4bb22d9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports